import { FC } from 'react';

export const Header: FC = ({ children }) => <h2>{children}</h2>;
